// @flow
// Превью лекала из его контуров, в стиле каталога: лекало залито серым,
// линии реза белые, фон прозрачный. Если превью исходного лекала стоит
// вертикально, а лекало в файле лежит боком, картинка поворачивается на 90°
// по часовой: так нарисованы превью в каталоге (верх превью — левый край
// лекала в файле).

import { fillPaths, segmentsClosed } from './prnModel';

const FILL = '#8f8f8f';

// paths — контуры: массивы сегментов [{ type: 'M'|'L'|'C', pts }]; box — габариты
export function renderPreviewPng(paths, box, { rotate = false, size = 1000 } = {}) {
  const w = box.maxX - box.minX || 1;
  const h = box.maxY - box.minY || 1;
  const k = (size * 0.96) / Math.max(w, h);
  const margin = size * 0.02;
  const w0 = w * k + 2 * margin;
  const h0 = h * k + 2 * margin;
  const canvas = document.createElement('canvas');
  canvas.width = Math.ceil(rotate ? h0 : w0);
  canvas.height = Math.ceil(rotate ? w0 : h0);
  const g = canvas.getContext('2d');

  // Точка лекала (ось Y вверх) → точка картинки
  const at = (x, y) => {
    const sx = (x - box.minX) * k + margin;
    const sy = (box.maxY - y) * k + margin;
    return rotate ? [h0 - sy, sx] : [sx, sy];
  };

  const trace = list => {
    g.beginPath();
    list.forEach(segs => segs.forEach(s => {
      if (s.type === 'C') {
        const [x1, y1] = at(s.pts[0], s.pts[1]);
        const [x2, y2] = at(s.pts[2], s.pts[3]);
        const [x3, y3] = at(s.pts[4], s.pts[5]);
        g.bezierCurveTo(x1, y1, x2, y2, x3, y3);
      } else {
        const [x, y] = at(s.pts[0], s.pts[1]);
        if (s.type === 'M') g.moveTo(x, y); else g.lineTo(x, y);
      }
    }));
  };
  // Заливка — только то, что вырезается; линии — все, и открытые тоже
  const lineWidth = Math.max(1, size * 0.004);
  trace(fillPaths(paths));
  g.fillStyle = FILL;
  g.fill('evenodd');
  // У открытой линии вне заливки белое на прозрачном не видно: серая кайма
  trace(paths.filter(segs => !segmentsClosed(segs)));
  g.strokeStyle = FILL;
  g.lineWidth = lineWidth * 2.5;
  g.stroke();
  trace(paths);
  g.strokeStyle = '#ffffff';
  g.lineWidth = lineWidth;
  g.stroke();

  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => (blob ? resolve(blob) : reject(new Error('Не удалось нарисовать превью'))), 'image/png');
  });
}
